import Box from '@mui/material/Box';
import SoftTypography from 'components/SoftTypography/index.js';
import { Button, CircularProgress, Stack, TextField } from '@mui/material';
import Flatpickr from 'react-flatpickr';
import PropTypes from "prop-types";
import SoftInput from 'components/SoftInput';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import IconArticleIcon from '@mui/icons-material/Article';
import { Spanish } from 'flatpickr/dist/l10n/es.js';

const flatpickrOptions = {
  locale: Spanish,
  dateFormat: 'd-m-Y',
};

export function DataGridFilter({ filter, handleFilterChange, handleGenerateReport, loading }) {

    DataGridFilter.propTypes = {
        filter: PropTypes.object.isRequired,
        handleFilterChange: PropTypes.func.isRequired,
        handleGenerateReport: PropTypes.func,
        loading: PropTypes.bool,
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: {
                    xs: 'column',
                    sm: 'row',
                    md: 'row',
                    lg: 'row',
                    xl: 'row',
                },
                gap: 2,
                alignItems: 'center',
                p: 2,
                borderRadius: 1,
                boxShadow: 1,
                mb: 2,
                mt: {
                    xs: 1,
                    sm: 1,
                    md: 0,
                },
                bgcolor: "#FFFFFF",
            }}
        >
            <SoftTypography>Filtros:</SoftTypography>

            {(filter.startDate != null && filter.endDate != null) &&
                <Box sx={{
                    display: 'flex',
                    gap: '1rem',
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: '100%',
                        xl: '30%',

                    }
                }}>
                    <Flatpickr
                        value={filter.startDate}
                        options={flatpickrOptions}
                        className="customPicker"
                        placeholder="Desde"
                        onChange={(_, dateStr) => handleFilterChange('startDate', dateStr)}

                    />
                    <Flatpickr
                        value={filter.endDate}
                        options={flatpickrOptions}
                        className="customPicker"
                        placeholder="Hasta"
                        onChange={(_, dateStr) => handleFilterChange('endDate', dateStr)}
                    />
                </Box>
            }

            {(filter.search != null &&
                <Box sx={{
                    display: 'flex',
                    gap: '1rem',
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: '100%',
                        xl: '20%',

                    }
                }}>
                    <SoftInput
                        type="text"
                        placeholder="Buscar"
                        value={filter.search}
                        name="search"
                        onChange={e => handleFilterChange('search', e.target.value)}
                        autoComplete="given-name"
                    />
                </Box>
            )}

            <Button
                variant="none"
                onClick={() => {
                    handleFilterChange('clean');
                }}
                sx={{
                    backgroundColor: "#4A80A8",
                    color: "#FFFFFF !important",
                    '&:hover': {
                        backgroundColor: "#4A80A8 !important"
                    }
                }}
                disabled={
                    Object.values(filter).every((val) => val === '')
                }
            >
                Limpiar
            </Button>

            {(handleGenerateReport != null &&
                <SoftButton
                    color="color6V"
                    onClick={handleGenerateReport}
                    disabled={loading}
                >
                    {loading ?
                        <CircularProgress size={17} sx={{ color: "blue" }} />
                        :
                        <IconArticleIcon />
                    }


                </SoftButton>
            )}
        </Box>
    );
}

